import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Sparkles, ArrowRight } from "lucide-react";

export default function SegmentsSection() {
  const [segments, setSegments] = useState([]);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    api.get("/segments?active=true").then((r) => setSegments(r.data || [])).catch(() => {});
    api.get("/settings/public").then((r) => setEnabled(r.data?.discover_by_segments_enabled !== false)).catch(() => {});
  }, []);

  if (!enabled || segments.length === 0) return null;

  return (
    <section className="bg-gradient-to-b from-blue-950 to-stone-950 text-white py-16 sm:py-24 relative overflow-hidden" data-testid="segments-section">
      {/* texture */}
      <div className="absolute inset-0 opacity-[0.04]" style={{backgroundImage: "radial-gradient(circle at 20% 30%, white 1px, transparent 1px), radial-gradient(circle at 80% 70%, white 1px, transparent 1px)", backgroundSize: "60px 60px, 40px 40px"}}/>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative">
        <div className="flex flex-col items-center text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.25em] text-amber-400 font-bold"><Sparkles size={12}/> Novo no MorarBem</span>
          <h2 className="font-display text-3xl sm:text-5xl font-bold mt-3 max-w-3xl leading-tight">
            Descubra pelo seu <span className="text-amber-400">desejo</span>, não só pela categoria
          </h2>
          <p className="text-blue-100/80 mt-3 max-w-2xl">
            Estamos pensando em você. Escolha o que quer encontrar — comer bem, morar bem, se divertir — e a gente mostra tudo perto de você no mapa.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {segments.slice(0, 6).map((s) => (
            <Link
              key={s.slug}
              to={`/discover/all?segment=${s.slug}`}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 backdrop-blur hover:border-amber-400/60 hover:-translate-y-1 transition-all duration-300"
              data-testid={`landing-seg-${s.slug}`}
            >
              <div className="aspect-[16/9] bg-gradient-to-br from-blue-800/60 to-amber-700/40 overflow-hidden relative">
                {s.cover_url ? (
                  <img src={s.cover_url} alt={s.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 opacity-90"/>
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center text-white/30 font-display text-5xl">{s.name[0]}</div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-blue-950 via-blue-950/50 to-transparent"/>
              </div>
              <div className="absolute inset-0 flex flex-col justify-end p-5">
                <h3 className="font-display text-xl sm:text-2xl font-bold leading-tight">{s.cta || s.name}</h3>
                <p className="text-xs text-white/80 mt-1 line-clamp-2 max-w-xs">{s.description}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-amber-400 font-bold text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                  Descobrir <ArrowRight size={14}/>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link to="/discover/all" className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-amber-400 hover:bg-amber-300 text-amber-950 font-bold transition-all hover:gap-2" data-testid="landing-discover-cta">
            Ir para o descobrir <ArrowRight size={14}/>
          </Link>
        </div>
      </div>
    </section>
  );
}
